import { Spinner } from 'react-bootstrap';

interface Props {
  animation?: 'border' | 'grow';
  color: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light';
}

const Load = ({ color, animation = 'border' }: Props) => {
  return (
    <div className="d-flex justify-content-center py-2">
      <Spinner animation={animation} variant={color}>
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Load;
